import { SortingState } from "@tanstack/react-table";
import { AccountHoldersFilter } from "../atoms";
import {
  AccountHolder,
  FilterStatusEventType,
  MerchantAccount,
  OnboardingStatus,
} from "../services/accountService";
import onboardingStatusEvents from "../data/onboardingStatusEvents.json";

export function getEmptyAccountHolder(): AccountHolder {
  return {
    edition: "",
    jrId: "",
    adyenAccountHolderCode: "",
    legalEntityType: "",
    companyName: "",
    companyEmail: "",
    contactFirstName: "",
    contactLastName: "",
    country: "",
    adyenStatus: "",
    jrPayStatus: "",
    legalBusinessName: "",
    id: "",
    contactFullName: "",
    onboardingStatus: "In Progress",
    ratePlans: [],
    paymentProcessingState: false,
    payoutState: false,
    adyenMerchantAccount: "",
    adyenPayoutSchedule: {},
    accounts: [],
    shopperStatement: "",
    convFee: "",
    convFeeRate: "",
    techFeeRate: "",
    allowedPaymentMethods: [],
    merchantStatus: "",
    adyenCaptureDelay: "",
    accountHolderNotes: [],
    dailySubscription: null,
    monthlySubscription: null,
    useInterchangeRate: null,
    timeZoneCode: "",
    timeZone: {
      code: "",
      country: "",
      name: "",
      ianA_Name: "",
    },
    useTransAmountLimit: false,
    transAmountLimit: "",
    useDailyTransAmountLimit: false,
    dailyTransAmountLimit: "",
    useTechFee: false,
    useConvFee: false,
    legalEntityId: "",
    merchantAccountId: "",
    inBalancePlatform: false,
    balancePlatformAccountHolderId: "",
    migrated: false,
    migrationDate: "",
    hasMonthlyFee: false,
    monthlyFee: "",
    stores: [],
    verificationErrors: "",
    dateCreated: "",
    achDailyTransAmountLimit: "",
    achTransAmountLimit: "",
    useACHDailyTransAmountLimit: false,
    useACHTransAmountLimit: false,
    grantStatus: null,
    offerStatus: null,
    onboardingKYCStatus: "",
    duplicateDetectionMinutes: "",
    corpAccountHolderId: "",
    corpFee: "",
    corpFeeDescription: "",
    useCorpFee: false,
    fraudMonitoring: null,
  };
}

export function getEmptyMerchantAccount(): MerchantAccount {
  return {
    merchantAccountId: "",
    merchantAccountName: "",
    merchantAccountType: "",
    merchantCurrency: "",
    processingFeeAccount: "",
    techFeeAccount: "",
    balancePlatformId: "",
    balancePlatformProcFeeAccount: "",
    balancePlatformTechFeeAcount: "",
    themeId: "",
    merchantCountryCode: "",
    defaultForCountryCode: false,
  };
}

export function getOnboardingStatus(
  adyenStatus: string,
  jrPayStatus: string,
  migrated: boolean
): OnboardingStatus {
  if (adyenStatus === "Active" && jrPayStatus === "True") {
    return "Complete";
  } else if (adyenStatus === "Active" && jrPayStatus !== "True") {
    return migrated ? "KYC Needed" : "In Progress";
  }
  return "In Progress";
}

export function formatOnboardingStatusEvent(
  statusEvent: FilterStatusEventType
) {
  // find the event in the list
  const event = onboardingStatusEvents.find((e) => e.value === statusEvent);
  // return the label if found, otherwise format known events
  if (event) {
    return event.label;
  }
  return "Unknown status.";
}

export function getDefaultOnboardingFilter(): AccountHoldersFilter {
  return {
    accountHolderCode: "",
    status: "complete",
    statusEvent: "all",
    showClosed: false,
    pageNumber: 1,
    pageSize: 100,
    sort: [{ id: "dateCreated", desc: true }],
  };
}

function getOnboardingFilterSearchParams(filter: AccountHoldersFilter) {
  return Object.entries(filter).reduce((acc, [key, value], i) => {
    let formattedValue: string;
    switch (key) {
      case "sort":
        const defaultSort = value as SortingState;
        formattedValue = `${defaultSort.at(0)?.id}:${
          defaultSort.at(0)?.desc ? "desc" : "asc"
        }`;
        break;
      default:
        formattedValue = value as string;
    }
    return (
      acc + `${i > 0 ? "&" : ""}${key}=${encodeURIComponent(formattedValue)}`
    );
  }, "");
}

export function getOnboardingPageDefaultUrl() {
  return (
    "onboarding#" +
    getOnboardingFilterSearchParams(getDefaultOnboardingFilter())
  );
}
